import { memo } from "react";

function VagaroLogo() {
  return (
    <>
      <div className="vagaro-box">
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="40px"
          height="40px"
          viewBox="0 0 234.000000 213.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <metadata>
            Online Scheduling for Salons and Spas. Salon Software | Salon
            Appointment Software" title="Online Scheduling for Salons and Spas.
            Salon Software | Salon Appointment Software
          </metadata>
          <g
            transform="translate(0.000000,213.000000) scale(0.100000,-0.100000)"
            fill="#FFFFFF"
            stroke="none"
          >
            <path
              d="M283 2116 c-189 -61 -310 -260 -274 -452 6 -37 23 -89 37 -116 14
              -28 199 -350 410 -717 258 -447 399 -680 427 -709 84 -87 226 -132 349 -112
              82 13 172 58 225 112 28 29 170 265 428 713 213 368 397 690 410 716 101 198
              11 451 -193 547 -51 24 -69 27 -167 27 -103 0 -114 -2 -177 -32 -38 -18 -86
              -51 -111 -76 -28 -29 -119 -176 -258 -416 -117 -204 -216 -371 -219 -371 -3 0
              -75 120 -160 268 -311 539 -311 540 -430 596 -56 26 -78 31 -160 33 -60 2
              -110 -2 -137 -11z m232 -150 c28 -13 62 -36 77 -52 21 -22 483 -808 491 -834
              1 -4 -61 -116 -139 -251 -77 -134 -144 -253 -148 -263 -8 -24 32 -89 -331 539
              -159 275 -298 525 -308 555 -16 47 -17 63 -8 109 35 176 211 270 366 197z
              m1504 9 c125 -44 200 -179 168 -301 -17 -64 -788 -1404 -836 -1452 -19 -19
              -52 -43 -75 -53 -55 -25 -157 -25 -212 0 -49 22 -106 79 -130 129 -22 47 -30
              139 -15 185 16 48 782 1374 822 1421 63 75 181 106 278 71z"
            ></path>
            <path d="M1141 537 c-91 -31 -104 -162 -21 -210 85 -51 190 17 177 115 -10 77 -82 120 -156 95z"></path>
          </g>
        </svg>
      </div>
    </>
  );
}
export default memo(VagaroLogo);
